import { m } from "framer-motion";
import { styled } from "@mui/material/styles";
import { Button, Typography, Box } from "@mui/material";
import { MotionContainer, varBounce } from "components/animate";
import { APP_URLS } from "urls/AppUrls";
import Logo from "components/logo";
import useAuth from "hooks/useAuth";
import { useTranslation } from "react-i18next";
import Main from "layouts/auth/Main";

export type ErrorPageProps = {
  stepsToResolve?: string;
  errorMessage?: string;
  title?: string;
};


const ContentStyle = styled("div")(({ theme }) => ({
  maxWidth: "70%",
  maxHeight: "30%",
  margin: "auto",
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  backgroundColor: "white",
}));

export default function Error404Page({ stepsToResolve, errorMessage, title }: ErrorPageProps) {
  const { triggerLogout } = useAuth();
  const { t: translate } = useTranslation();
  document.body.style.backgroundColor = "#F4F6F8";

  return (
    <Main fullWidth component={MotionContainer}>
      <ContentStyle
        sx={{
          textAlign: "center",
          alignItems: "center",
          marginTop: "6%",
          paddingTop: "30px",
          paddingBottom: "30px",
          borderRadius: "16px",
        }}
      >
        <m.div variants={varBounce().in}>
          <Logo disabledLink sx={{ ml: -20, mb: 6, width: 64, height: 64 }} />
        </m.div>
        <m.div variants={varBounce().in} style={{ marginBottom: 15 }}>
          <Typography variant="h2" sx={{ px: 5, mt: 2, mb: 2 }}>
            404: {title ?? translate("page_not_found")}
          </Typography>
          <Typography variant="body1" sx={{ color: "text.primary", mt: 2 }}>
            {errorMessage ?? translate("error_404_text_1")}
          </Typography>
          <Typography variant="body1" sx={{ color: "text.primary", mb: 2 }}>
            {stepsToResolve ?? translate("error_404_text_2")}
          </Typography>
        </m.div>
        <Box sx={{ mb: 5 }}>
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
            <Box sx={{ flexShrink: 0 }}>
              <Button
                size="large"
                variant="outlined"
                onClick={async () => {
                  await triggerLogout();
                }}
                sx={{
                  mx: 3,
                  pr: 4,
                  textTransform: "none",
                  color: "text.primary",
                  borderColor: "grey.300",
                  "&:hover": {
                    color: "text.primary",
                    borderColor: "grey.900",
                  },
                }}
              >
                {translate("go_to_otelier")}
              </Button>
              <Button
                size="large"
                variant="outlined"
                onClick={() => (window.location.href = APP_URLS.HOME)}
                sx={{
                  backgroundColor: "text.primary",
                  textTransform: "none",
                  color: "white",
                  "&:hover": {
                    color: "black",
                    borderColor: "grey.900",
                  },
                }}
              >
                Go to Home
              </Button>
            </Box>
          </Box>
        </Box>
        <m.div>
          <Typography variant="body2" sx={{ color: "text.primary", mb: 2 }}>
            {"\u00A9"} 2024 Otelier. {translate("all_reserved")}
          </Typography>
        </m.div>
      </ContentStyle>
    </Main>
  );
}
